import { isEmpty, isNil } from 'ramda';

export const getImageCoords = (enteredCoords: number[]) => {
  if (isEmpty(enteredCoords) || isNil(enteredCoords)) return [50, 50];
  return enteredCoords;
};
